// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qPTz","rootMobile":"styles_rootMobile__2XdRg"};